import { AccountNetworkIcon } from './AccountNetworkIcon';

/**
 * author: Austin Andrews
 * id 8F49C741-4ED8-4DD3-A22E-310C039EDDA6
 * name account-network
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-network.svg
 * tags
 * - Account / User 
 */
export const UserNetworkIcon = AccountNetworkIcon;
export default UserNetworkIcon